"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var AccessRestrictedIcon_1 = __importDefault(require("../../../Icons/Notifications/AccessRestrictedIcon"));
var i18N = {
    en: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "Access to your Worlds has been restricted due to",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "insufficient resources"),
            ".")); },
        title: 'Worlds restricted'
    },
    es: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El acceso a tus Mundos ha sido restringido debido a",
            ' ',
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "falta de recursos"),
            ".")); },
        title: 'Mundos restringidos'
    },
    zh: {
        description: function (link) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u7531\u4E8E\u8D44\u6E90\u4E0D\u8DB3\uFF0C",
            react_1.default.createElement("a", { href: link, className: "dcl notification-link" }, "\u8BBF\u95EE\u60A8\u7684\u4E16\u754C\u53D7\u5230\u9650\u5236"),
            ".")); },
        title: '世界限制'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var WorldsAccessRestrictedNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(AccessRestrictedIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata.url))));
};
exports.default = WorldsAccessRestrictedNotification;
